<script>
  import GalerieImages from '@/components/GalerieImages.vue'
  export default {
    name: 'Peintures',
    data() {
      return {
        peintures: [],
      }
    },
    mounted() {
      this.InitialiserDonnees()
    },
    methods: {
      async InitialiserDonnees() {
        const donneesBase = await fetch(
          'https://pascalchove.com/PeinturesService.php'
        )
        this.peintures = await donneesBase.json()
        this.peintures = this.peintures.sort((a, b) => b.ordre - a.ordre)
      },
    },
    computed: {
      peinturesAAfficher() {
        return this.peintures
      },
    },
    components: {
      GalerieImages,
    },
  }
</script>

<template>
  <h2>LES PEINTURES</h2>

  <GalerieImages :donnees="peinturesAAfficher" categorie="peintures" />
</template>
